import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import aboutBg from "../../images/bg/service-bg.png";
import gif from "../../images/icon/b10c3e43e836d32554bf.gif";
import arrowIcon from "../../images/icon/rotate-arrow-black.svg";

// Service images
import img01 from "../../images/service/img01.jpg";
import img02 from "../../images/service/img02.jpg";
import img03 from "../../images/service/img03.jpg";
import img04 from "../../images/service/img04.jpg";
import img05 from "../../images/service/img05.jpg";
import img06 from "../../images/service/img06.jpg";

const serviceImages = [img01, img02, img03, img04, img05, img06];

const ServiceSection: React.FC = () => {
  const { t } = useLanguage();
  const [activeId, setActiveId] = useState<number>(1);

  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-service-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  return (
    <section className="service pt-135">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="sec-title custom-sec-title xb-sec-padding text-center">
              <span className="sub-title">{t.services.sectionSub}</span>
              <h2 className="title">
                <span className="round-img">
                  <img src={gif} alt="gif" />
                </span>{" "}
                {t.services.title}
              </h2>
              <div className="xb-heading-btn d-inline">
                <Link className="thm-btn agency-btn" to="/service-details">
                  <span className="text">{t.services.viewAll}</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      {[...Array(2)].map((_, i) => (
                        <svg
                          key={i}
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="5.06592"
                            y="19.9785"
                            width="20.5712"
                            height="2.61221"
                            transform="rotate(-40.2798 5.06592 19.9785)"
                            fill="white"
                          />
                          <rect
                            x="7.97095"
                            y="7.24463"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 7.97095 7.24463)"
                            fill="white"
                          />
                          <rect
                            x="11.6523"
                            y="7.54834"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 11.6523 7.54834)"
                            fill="white"
                          />
                          <rect
                            x="15.334"
                            y="7.85205"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 15.334 7.85205)"
                            fill="white"
                          />
                          <rect
                            x="18.7119"
                            y="11.8374"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.7119 11.8374)"
                            fill="white"
                          />
                          <rect
                            x="18.4084"
                            y="15.52"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.4084 15.52)"
                            fill="white"
                          />
                          <rect
                            x="18.104"
                            y="19.2012"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.104 19.2012)"
                            fill="white"
                          />
                        </svg>
                      ))}
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Service Boxes */}
      <div className="xb-service-wrap bg_img">
        {t.services.items.map((service, idx) => {
          const imgSrc = serviceImages[idx] || img01;
          const link = `/service-details/${service.slug}`;
          return (
            <div
              key={service.id}
              className={`xb-service-item xb-border xb-mouseenter ${
                activeId === service.id ? "active" : ""
              }`}
              onMouseEnter={() => setActiveId(service.id)}
            >
              <div className="xb-item--inner">
                <div className="xb-item--item">
                  <div className="xb-item--head-item">
                    <h3 className="xb-item--title border-effect">
                      <Link to={link}>{service.title}</Link>
                    </h3>
                    <Link className="xb-item--icon" to={link}>
                      <img src={arrowIcon} alt="arrow" />
                    </Link>
                  </div>
                  <p className="xb-item--content">{service.shortDesc}</p>
                  <div className="xb-item--img xb-img">
                    <Link to={link}>
                      <img src={imgSrc} alt={service.title} />
                    </Link>
                  </div>
                </div>

                <div className="service-vertical-text">
                  <h3 className="xb-item--title">
                    <Link to={link}>{service.title}</Link>
                  </h3>
                  <Link className="xb-icon" to={link}>
                    <svg
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="6.28979"
                        y="21.4111"
                        width="22.36"
                        height="2.83936"
                        transform="rotate(-40.2798 6.28979 21.4111)"
                        fill="white"
                      />
                      <rect
                        x="9.44751"
                        y="7.57031"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 9.44751 7.57031)"
                        fill="white"
                      />
                      <rect
                        x="13.449"
                        y="7.90015"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 13.449 7.90015)"
                        fill="white"
                      />
                      <rect
                        x="17.4507"
                        y="8.23047"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 17.4507 8.23047)"
                        fill="white"
                      />
                      <rect
                        x="21.1223"
                        y="12.5627"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 21.1223 12.5627)"
                        fill="white"
                      />
                      <rect
                        x="20.7925"
                        y="16.5649"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 20.7925 16.5649)"
                        fill="white"
                      />
                      <rect
                        x="20.4617"
                        y="20.5667"
                        width="2.83936"
                        height="2.83936"
                        transform="rotate(-40.2798 20.4617 20.5667)"
                        fill="white"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ServiceSection;
